export default {
  ANALYST: "Аналитик",
  ACCOUNTANT: "Бухгалтер",
  CASHIER: "Кассир",
  HEAD_OP_DEP: "Начальник отдела эксплуатации АПВ",
  ENGINEER: "Инженер",
  PROGRAMMER: "Программист",
  DISPATCHER: "Диспетчер",
};
